import React, { useState } from 'react';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { API_BASE } from '../../config/api';
import { formatApiErrorDetail } from '../../lib/apiError';

const field = 'pl-10 bg-navigate-surface border-zinc-800 text-white placeholder:text-zinc-500 focus:border-navigate-gold focus:ring-navigate-gold';

export default function EmailPasswordForm({ primaryColor, onError, initialEmail = '' }) {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    onError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/api/auth/login`, { email: email.trim(), password });
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify(data.user));
      toast.success(`Welcome back${data.user?.full_name ? `, ${data.user.full_name.split(' ')[0]}` : ''}`);
      window.location.href = '/dashboard';
    } catch (err) {
      onError(formatApiErrorDetail(err.response?.data?.detail, 'Unable to sign in. Please try again.'));
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="email-login-form">
      <div className="space-y-2">
        <Label htmlFor="email" className="text-zinc-300">Email</Label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-zinc-500" />
          <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com" className={field} data-testid="login-email-input" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="password" className="text-zinc-300">Password</Label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-zinc-500" />
          <Input id="password" type={show ? 'text' : 'password'} autoComplete="current-password" required value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="Your password" className={`${field} pr-10`} data-testid="login-password-input" />
          <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300"
            aria-label={show ? 'Hide password' : 'Show password'} data-testid="login-password-toggle">
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      </div>
      <button type="submit" disabled={loading} className="w-full btn-gold disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ backgroundColor: primaryColor, borderColor: primaryColor }} data-testid="login-submit-btn">
        {loading ? 'Signing in…' : 'Sign in'}
      </button>
      <p className="text-xs text-center text-zinc-500">Forgot your password? Ask your administrator to reset it.</p>
    </form>
  );
}
